import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenContainer"]
  static values = { selected: Array, inputName: String }

  connect() {
    this._syncPillStyles()
    this._updateHiddenInputs()
  }

  selectedValueChanged() {
    this._syncPillStyles()
    if (this.hasHiddenContainerTarget) {
      this._updateHiddenInputs()
    }
  }

  toggle(event) {
    const lang = event.currentTarget.dataset.languageSelectValue
    const pill = event.currentTarget
    const isSelected = this.selectedValue.includes(lang)

    if (isSelected) {
      this.selectedValue = this.selectedValue.filter(l => l !== lang)
      this._setInactive(pill)
    } else {
      this.selectedValue = [...this.selectedValue, lang]
      this._setActive(pill)
    }
  }

  _syncPillStyles() {
    this.element.querySelectorAll("[data-language-select-value]").forEach((pill) => {
      const lang = pill.dataset.languageSelectValue
      if (this.selectedValue.includes(lang)) {
        this._setActive(pill)
      } else {
        this._setInactive(pill)
      }
    })
  }

  // Aligné sur app_project_steps_controller.js #syncPlatformPills (wizard clair)
  _setActive(pill) {
    pill.style.background = "rgba(var(--ls-accent-rgb),0.08)"
    pill.style.border = "1px solid rgba(var(--ls-accent-rgb),0.4)"
    pill.style.color = "var(--ls-accent)"
  }

  _setInactive(pill) {
    pill.style.background = "rgba(255,255,255,0.9)"
    pill.style.border = "1px solid rgba(15,23,42,0.12)"
    pill.style.color = "rgba(15,23,42,0.65)"
  }

  _updateHiddenInputs() {
    this.hiddenContainerTarget.innerHTML = ""

    if (this.selectedValue.length === 0) {
      const empty = document.createElement("input")
      empty.type = "hidden"
      empty.name = this.inputNameValue
      empty.value = ""
      this.hiddenContainerTarget.appendChild(empty)
      return
    }

    this.selectedValue.forEach(lang => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = this.inputNameValue
      input.value = lang
      this.hiddenContainerTarget.appendChild(input)
    })
  }
}
